import axios from "axios";

import {
    CHANGE_USER_ADDRESS,
    RESET_USER_ADDRESS,
    CHANGE_USER_INFO,
    RESET_USER_INFO,
    NOVA_POSHTA_GET_DEPARTMENS_LOADING,
    NOVA_POSHTA_GET_TOWNS_LOADING,
    NOVA_POSHTA_SET_DEPARTMENS,
    NOVA_POSHTA_SET_TOWNS,
    CHANGE_STEP_BUY_FLOW,
    RESET_STEP_BUY_FLOW,
    BACK_STEP_BUY_FLOW,
} from "../mutation-types";

import { NOVA_POSHTA_GET_DEPARTMENS, NOVA_POSHTA_GET_TOWNS } from "../action-types";

const state = {
    userInfo: {
        // total_sum: 0,
        // delivery_date: 0,
        id: "",
        name: "",
        second_name: "",
        last_name: "",
        email: "",
        phone: "",
        city: "",
        street: "",
        house: "",
        flat: "",
        town: "",
        department: "",
        recipient: 0,
        delivery: "",
        affiliate_id: "",
        agent_client_id: "",
    },
    userAddress: {
        town: "",
        department: "",
        status: false,
    },
    isDepartmensLoading: false,
    isTownsLoading: false,
    towns: [],
    departments: [],
    buyFlow: 0,
};

const getters = {
    userInfo: state => state.userInfo,
    buyFlow: state => state.buyFlow,
    userAddress: state => state.userAddress,
    isDepartmensLoading: state => state.isDepartmensLoading,
    isTownsLoading: state => state.isTownsLoading,
    towns: state => state.towns,
    departments: state => state.departments,
};

const actions = {
    [NOVA_POSHTA_GET_TOWNS]: async ({ commit }, payload) => {
        commit(NOVA_POSHTA_GET_TOWNS_LOADING, true);
        try {
            const response = await axios({
                method: "POST",
                url: "https://api.novaposhta.ua/v2.0/json/",
                data: payload,
            });
            commit(NOVA_POSHTA_SET_TOWNS, response.data.data);
            commit(NOVA_POSHTA_SET_DEPARTMENS, []);
        } catch (e) {
            throw e;
        } finally {
            commit(NOVA_POSHTA_GET_TOWNS_LOADING, false);
        }
    },
    [NOVA_POSHTA_GET_DEPARTMENS]: async ({ commit }, payload) => {
        commit(NOVA_POSHTA_GET_DEPARTMENS_LOADING, true);
        try {
            const response = await axios({
                method: "POST",
                url: "https://api.novaposhta.ua/v2.0/json/",
                data: payload,
            });
            commit(NOVA_POSHTA_SET_DEPARTMENS, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(NOVA_POSHTA_GET_DEPARTMENS_LOADING, false);
        }
    },
};

const mutations = {
    [CHANGE_USER_INFO](state, data) {
        console.log(data, "data");
        Object.assign(state.userInfo, data);
    },
    [RESET_USER_INFO](state) {
        for (let i in state.userInfo) {
            state.userInfo[i] = "";
        }
    },
    [CHANGE_USER_ADDRESS](state, data) {
        Object.assign(state.userAddress, data);
    },
    [RESET_USER_ADDRESS](state) {
        for (let i in state.userAddress) {
            state.userAddress[i] = "";
        }
    },
    [NOVA_POSHTA_GET_DEPARTMENS_LOADING](state, status) {
        state.isDepartmensLoading = status;
    },
    [NOVA_POSHTA_GET_TOWNS_LOADING](state, status) {
        state.isTownsLoading = status;
    },
    [NOVA_POSHTA_SET_TOWNS](state, data) {
        state.towns = data;
    },
    [NOVA_POSHTA_SET_DEPARTMENS](state, data) {
        state.departments = data;
    },
    [CHANGE_STEP_BUY_FLOW](state) {
        state.buyFlow += 1;
    },
    [BACK_STEP_BUY_FLOW](state) {
        state.buyFlow -= 1;
    },
    [RESET_STEP_BUY_FLOW](state) {
        state.buyFlow = 0;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
